import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'contentUrl' })
export class ContentUrlPipe implements PipeTransform {
    transform(url: string) {
        return url.replace(/^\/en\/us/, '');
    }
}
